import { CrawlNotificationAction } from '@aibees/elephant/components/crawl-notification-action';
import { NotificationExportToRouteButton } from '@aibees/elephant/components/notification-export-to-route-button';
import { IconType } from '@aibees/shared/components';
import { SHARED_ROUTES } from '@aibees/shared/constants';
import {
  NotificationItem,
  NotificationMetadataStatus,
  NotificationType,
} from '@aibees/shared/features/notifications';
import { ReactNode } from 'react';
export const notificationIconMap: Record<NotificationType, IconType> = {
  Account: 'account-list',
  CRAWL: 'database-search-outline',
  EXPORT: 'export',
  EXPORT_INTEGRATION: 'export',
  Subscription: 'finances',
  Update: 'update',
  SaveRecords: 'save',
  SaveSearch: 'bookmark',
  PriceAndPlan: 'receipt-outline',
  AssignOwner: 'account-tag',
  Label: 'label-outline',
  List: 'list',
  EXPORT_ENRICHMENT: 'view-in-ar',
  AddLabel: 'ic-new-label',
  AddList: 'list-add',
  RemoveLabel: 'label-off-outline',
  RemoveList: 'list-remove',
  ContactDetails: 'email-outline',
  ProfileInsight: 'badge-outline',
  AiPersonality: 'person-search-outline',
  Profile: 'user-circle',
  UserManagement: 'black-people-group',
  EnrichSaveRecord: 'outline-find-replace',
  Integration: 'power',
  Enrich: 'outline-find-replace',
  TableLayoutModifier: 'view-week-outline',
  Download: 'file-download-outline',
  CSVTemplate: 'file-csv-outline',
  phoneUnlock: 'phone',
};

export const notificationBodyMap: Partial<
  Record<
    NotificationType,
    Partial<Record<Partial<NotificationMetadataStatus>, string>>
  >
> = {
  Account: {
    SUCCESS: 'Account {name} has been successfully {status}',
    FAILED: 'Account {name} has failed to {status}',
    PROCESSING: 'Account {name} is {status}',
  },
  CRAWL: {
    SUCCESS: 'Crawl request for {name} has been successfully {status}',
    FAILED: 'Crawl request for {name} has failed to {status}',
    PROCESSING: 'Crawl request for {name} is {status}',
  },
  EXPORT: {
    SUCCESS: 'Export {name} has been successfully {status}',
    FAILED: 'Export {name} has failed to {status}',
    PROCESSING: 'Export {name} is {status}',
  },
  EXPORT_INTEGRATION: {
    SUCCESS: 'Export {name} has been successfully {typeAlias}',
    FAILED: 'Export {name} has failed to {typeAlias}',
    PROCESSING: 'Export {name} is {status}',
  },

  Subscription: {
    SUCCESS: 'Subscription {name} has been successfully {status}',
    FAILED: 'Subscription {name} has failed to {status}',
    PROCESSING: 'Subscription {name} is {status}',
  },
  Update: {
    SUCCESS: 'Update {name} has been successfully {status}',
    FAILED: 'Update {name} has failed to {status}',
    PROCESSING: 'Update {name} is {status}',
  },
  SaveRecords: {
    SUCCESS: 'Update {name} has been successfully {status}',
  },
  SaveSearch: {
    SUCCESS: 'Update {name} has been successfully {status}',
  },
  PriceAndPlan: {
    SUCCESS: 'Update {name} has been successfully {status}',
  },
};

export const notificationTitleMap: Partial<
  Record<
    NotificationType,
    Partial<Record<Partial<NotificationMetadataStatus>, string>>
  >
> = {
  Account: {
    SUCCESS: 'Account {name} has been successfully {status}',
    FAILED: 'Account {name} has failed to {status}',
    PROCESSING: 'Account {name} is {status}',
  },
  CRAWL: {
    SUCCESS: 'Crawling Succeeded',
    FAILED: 'Crawling Unsuccessful',
    PROCESSING: 'Your crawl request is in progress',
  },
  EXPORT: {
    SUCCESS: 'File is Ready to Download ',
    FAILED: 'Please Wait – Request in Progress!',
    PROCESSING: 'Export file is progress',
  },
  EXPORT_INTEGRATION: {
    SUCCESS: 'File is Ready to Download ',
    FAILED: 'Export to {integration.typeAlias} Failed',
    PROCESSING: 'Export file is progress',
  },

  Subscription: {
    SUCCESS: 'Subscription {name} has been successfully {status}',
    FAILED: 'Subscription {name} has failed to {status}',
    PROCESSING: 'Subscription {name} is {status}',
  },
  Update: {
    SUCCESS: 'Update {name} has been successfully {status}',
    FAILED: 'Update {name} has failed to {status}',
    PROCESSING: 'Update {name} is {status}',
  },
  SaveRecords: {
    SUCCESS: 'Your save records process is complete',
  },
  SaveSearch: {
    SUCCESS: 'Your save records process is complete',
  },
  PriceAndPlan: {
    SUCCESS: 'Downgrade Successful!',
  },
};

export const notificationMetadataMap: Partial<
  Record<NotificationType, (item: NotificationItem) => ReactNode>
> = {
  EXPORT_ENRICHMENT: (item) => (
    <NotificationExportToRouteButton
      item={item}
      route={`${SHARED_ROUTES.enrichPage}?id=${item.message.requestId}`}
      title="View Enrichment"
    />
  ),
  EXPORT: (item) => (
    <NotificationExportToRouteButton
      item={item}
      route={`${SHARED_ROUTES.searchListExport}/${item.message.requestId}`}
      title="View Exports"
    />
  ),
  EXPORT_INTEGRATION: (item) => (
    <NotificationExportToRouteButton
      item={item}
      route={`${SHARED_ROUTES.searchListExport}/${item.message.requestId}`}
      title="View Exports"
    />
  ),
  CRAWL: (item) => <CrawlNotificationAction item={item} />,
};
